import { AddActivityForm } from "@/forms/AddActivityForm/AddActivityForm";
import { type IPatientId } from "@medoma/models/patients";
import { canAddActivitiesToPatient } from "./newActivityUtils";
import { useNewActivityOutletContext } from "./newActivityUtils";
import { usePatient } from "@/api/Patients";
import { Trans, useLingui } from "@lingui/react/macro";
import { Text } from "@medoma/components/Text/Text";
import { Loading } from "@medoma/components/Loading/Loading";
import ErrorMessage from "@medoma/components/ErrorMessage/ErrorMessage";
import { deducedError } from "@/Utils/ErrorUtils";

const CustomActivity = () => {
  const { patientId } = useNewActivityOutletContext();

  return (
    <>
      {patientId ? (
        <WithPatientId patientId={patientId} />
      ) : (
        <WithoutPatientId />
      )}
    </>
  );
};

const WithPatientId = ({ patientId }: { patientId: IPatientId }) => {
  const { data: patient, isPending, isError, error } = usePatient(patientId);
  const { t } = useLingui();

  if (isPending) {
    return <Loading message={t`Hämtar information om patient`} />;
  }

  if (isError) {
    return (
      <ErrorMessage
        message={`${t`Kunde inte hämta information om patient`} ${deducedError(error)}`}
      />
    );
  }

  if (!canAddActivitiesToPatient(patient)) {
    return (
      <Text element="p" color="faded">
        <Trans>
          Patienten har fått avslag eller arkiverats. Aktiviteter kan inte
          läggas till.
        </Trans>
      </Text>
    );
  }

  return <AddActivityForm patientId={patientId} />;
};

const WithoutPatientId = () => <AddActivityForm patientId={undefined} />;

export { CustomActivity };
